import { render, staticRenderFns } from "./FilterTagsModal.vue?vue&type=template&id=1625b69c&scoped=true"
import script from "./FilterTagsModal.vue?vue&type=script&lang=js"
export * from "./FilterTagsModal.vue?vue&type=script&lang=js"
import style0 from "./FilterTagsModal.vue?vue&type=style&index=0&id=1625b69c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1625b69c",
  null
  
)

export default component.exports